import { Text } from "@react-pdf/renderer";
import React from "react";

const DocumentDetailDescription = ({
  children,
  ...rest
}: React.HTMLAttributes<HTMLDivElement>) => {
  return (
    <Text
      {...rest}
      style={{
        fontFamily: "Pretendard",
        fontSize: "10pt",
        fontWeight: 600,
        marginBottom: "7.9mm",
      }}
    >
      {children}
    </Text>
  );
};

export default DocumentDetailDescription;
